/**
 * Slug estable para anclas de encabezados BBCode ([h2], [h3]).
 * Debe coincidir entre extractTocFromBBCode y BBCodeParser.
 */
export function slugifyHeading(text) {
  const plain = String(text || '')
    .replace(/<[^>]+>/g, '')
    .replace(/&[#\w]+;/g, ' ')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return plain || 'section'
}

export function uniqueHeadingSlug(text, usedSlugs) {
  const base = slugifyHeading(text)
  let slug = base
  let i = 2
  while (usedSlugs.has(slug)) {
    slug = `${base}-${i++}`
  }
  usedSlugs.add(slug)
  return slug
}
